import React from 'react';
import { IconButton } from '@mui/material';

interface ButtonProps {
  Icon: any;
  onClick: () => void;
  sx?: any;
}

export function Button({
  Icon,
  onClick,
  sx,
}: ButtonProps) {
  return (
    <IconButton
      onClick={onClick}
      sx={{
        width: '32px',
        height: '32px',
        borderRadius: '8px',
        border: '1px solid #D6D6DB',
        color: '#1F1F1F',
        fontSize: '16px',
        ...sx,
      }}
      disableRipple>
      <Icon fontSize="inherit"/>
    </IconButton>
  );
}
